import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'moedabrasil'
})
export class MoedaBrasilPipe implements PipeTransform {

    transform(numero: number): string {
        if (numero !== undefined && numero !== null) {
            if (this.isInt(numero)) {
                return 'R$ ' + numero.toLocaleString('pt-BR') + ',00';
            }
            return 'R$ ' + numero.toLocaleString('pt-BR');
        } else {
            return '';
        }
    }

    private isInt(n: any) {
        return n % 1 === 0;
    }
}


// WEBPACK FOOTER //
// ./src/app/_pipes/moeda-brasil.pipe.ts